// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bag{position:fixed;top:50%;left:50%;z-index:999;transform:translate(-50%,-50%);width:139px}.start{position:relative;top:-30px;left:68px}.start>img{position:absolute}", ""]);
// Exports
module.exports = exports;
